import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { useFormContext } from '../../contexts/FormContext';

const ButtonGroupField = ({ field }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  const selectedValue = getFormDataItem(formData, field.name);

  const handleButtonChange = (event, newValue) => {
    if (newValue !== null) {
      handleChange(
        {
          target: {
            name: field.name,
            value: newValue,
            type: 'select',
          },
        },
        field,
      );
    }
  };

  return (
    <Grid size={field.size || 12} key={field.name}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <ToggleButtonGroup
            value={selectedValue}
            exclusive
            onChange={handleButtonChange}
            aria-label={field.label}
            fullWidth
            disabled={field.disabled || false}
            color="primary"
          >
            {field.options.map((option) => (
              <ToggleButton
                key={option.value}
                value={option.value}
                sx={{
                  flex: 1,
                  textTransform: 'none',
                  position: 'relative',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {option.label}
                  {option.help && <ChartHelpTooltip chartType={option.help} type="label" />}
                </Box>
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      </Box>
    </Grid>
  );
};

export default ButtonGroupField;
